import { memo } from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';

function AddActionButton({ children, handleOnClick }) {
  return (
    <Button color="default" variant="filled" icon={<PlusOutlined />} onClick={handleOnClick}>
      {children}
    </Button>
  );
}

export default memo(AddActionButton);
